import client from "../client";

const ISSUE_FOLDER = "MrIssues";

export async function uploadIssueMedia(
	file: File,
	onProgress?: (fraction: number) => void
): Promise<string> {
	const initRes = await client(
		`/v1/S3Upload/initiate?fileName=${encodeURIComponent(file.name)}&folder=${ISSUE_FOLDER}`,
		{ method: "POST", version: "Tasking" }
	);
	const { key, uploadId, chunkSize } = initRes.data;
	const size = chunkSize || 10 * 1024 * 1024;
	const totalParts = Math.ceil(file.size / size);
	const partETags = [];

	async function uploadPart(partNumber: number) {
		const blob = file.slice(
			(partNumber - 1) * size,
			Math.min(partNumber * size, file.size)
		);
		const presignRes = await client(
			`/v1/S3Upload/part-url?key=${encodeURIComponent(
				key
			)}&uploadId=${uploadId}&partNumber=${partNumber}`,
			{ method: "GET", version: "Tasking" }
		);
		const uploadRes = await fetch(presignRes.data.url, {
			method: "PUT",
			body: blob,
		});
		if (!uploadRes.ok) throw new Error(`Part ${partNumber} failed`);

		partETags.push({
			PartNumber: partNumber,
			ETag: uploadRes.headers.get("ETag").replace(/"/g, ""),
		});
		onProgress?.(partNumber / totalParts);
	}

	await Array.from({ length: totalParts }, (_, i) => i + 1).reduce(
		(chain, partNumber) => chain.then(() => uploadPart(partNumber)),
		Promise.resolve()
	);

	const completeRes = await client("/v1/S3Upload/complete", {
		method: "POST",
		version: "Tasking",
		data: { Key: key, UploadId: uploadId, PartETags: partETags },
	});
	return completeRes.data.location.replace(/%2F/gi, "/");
}
